import store from "redux/store";
import { add as addError } from "redux/errors/errorsSlice";
import { getGraphqlUrl } from "config";
import { createApolloClient } from "graphql/client";
import { createStoreTokenProvider, startAuth } from "auth/setupAuth";

/**
 * App-wide singletons, wired together in one place:
 * Redux store -> token provider -> GraphQL client.
 */

export const tokenProvider = createStoreTokenProvider(store);

export const graphqlClient = createApolloClient({
  uri: getGraphqlUrl(),
  getToken: tokenProvider.getValidIdToken,
  forceRefresh: tokenProvider.forceRefresh,
  reportError: (message) => store.dispatch(addError({ message })),
});

/** Starts the auth lifecycle. Returns a cleanup function. */
export function startServices(): () => void {
  return startAuth({
    store,
    tokenProvider,
    // New user (or none): drop cached data and refetch what's on screen.
    onUserChanged: () => {
      graphqlClient.resetStore().catch(() => undefined);
    },
  });
}
